const urlParser = require('url');

// Helper to replace purely integer sections of url paths with `:id`. This is useful for grouping errors together in DataDog and Sentry.

const maskIdsFromUrl = (url) => {
  if (!url) return '';
  const { protocol, hostname, pathname, search } = urlParser.parse(url);

  const maskedPath = pathname
    .split('/')
    .map((p) => {
      // Check if the sections of the path are only integers, if so assume they are ids
      // and return an :id placeholder.
      if (/^\d+$/.test(p)) {
        return ':id';
      }
      return p;
    })
    .join('/');

  // If there is a protocol present then we want to return the full url. Otherwise just return the masked path.
  if (protocol) {
    return `${protocol}//${hostname}${maskedPath}${search || ''}`;
  }

  return maskedPath;
};

module.exports = {
  maskIdsFromUrl,
};
